import React, { useState, useEffect } from 'react';
import { api } from '../../utils/api';
import toast from 'react-hot-toast';
import { Image as ImageIcon, Trash2 } from 'lucide-react'; // <-- Importamos icono

export const AnnouncementManagement: React.FC = () => {
    const [announcements, setAnnouncements] = useState<any[]>([]);
    const [message, setMessage] = useState('');
    const [imageUrl, setImageUrl] = useState(''); // <-- [NUEVO] Estado para la URL de la imagen

    const fetchAnnouncements = async () => {
        const data = await api.getAllAnnouncements();
        setAnnouncements(data);
    };

    useEffect(() => {
        fetchAnnouncements();
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            // [MODIFICADO] Enviamos también la URL de la imagen
            await api.createAnnouncement({ message, imageUrl });
            setMessage('');
            setImageUrl(''); // Limpiamos el campo
            fetchAnnouncements();
            toast.success('Anuncio creado con éxito.');
        } catch (error) {
            toast.error('Error al crear el anuncio.');
        }
    };

    const handleDelete = async (id: number) => {
        if (confirm('¿Seguro que quieres borrar este anuncio?')) {
            try {
                await api.deleteAnnouncement(id);
                fetchAnnouncements();
                toast.success('Anuncio eliminado.');
            } catch (error) {
                toast.error('Error al eliminar el anuncio.');
            }
        }
    };

    return (
        <div className="space-y-8">
            <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Crear Nuevo Anuncio</h3>
                <form onSubmit={handleSubmit} className="bg-white p-6 rounded-xl border space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Mensaje del Anuncio</label>
                        <input type="text" value={message} onChange={e => setMessage(e.target.value)} placeholder="Escribe tu anuncio..." className="mt-1 w-full p-2 border rounded-md" required />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">URL de la Imagen (Opcional)</label>
                        <input type="text" value={imageUrl} onChange={e => setImageUrl(e.target.value)} placeholder="https://ejemplo.com/imagen.png" className="mt-1 w-full p-2 border rounded-md" />
                    </div>
                    <div className="flex justify-end">
                        <button type="submit" className="bg-blue-600 text-white px-5 py-2 rounded-lg hover:bg-blue-700">Crear Anuncio</button>
                    </div>
                </form>
            </div>
            <div>
                <h3 className="text-xl font-bold text-gray-900 mb-4">Anuncios Existentes</h3>
                <div className="bg-white rounded-xl border">
                    <ul className="divide-y divide-gray-200">
                        {announcements.map(ad => (
                            <li key={ad.id} className="p-4 flex justify-between items-center">
                                <div className="flex items-center space-x-3">
                                    {ad.imageUrl && <ImageIcon className="w-5 h-5 text-gray-400" />}
                                    <p>{ad.message}</p>
                                </div>
                                <button onClick={() => handleDelete(ad.id)} className="text-red-500 hover:text-red-700 p-2 rounded-full hover:bg-red-50"><Trash2 className="w-4 h-4" /></button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};
